import React, { useEffect, useState } from "react";
import "./Zoomable.css";

const Zoomable = ({ children, label }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <div
        className="zoomable"
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        aria-label={label ? `Expand: ${label}` : "Expand image"}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(true);
          }
        }}
      >
        {children}
        <span className="zoomable__hint">
          <i className="fa-solid fa-magnifying-glass-plus"></i>
        </span>
      </div>

      {open && (
        <div
          className="zoomable-overlay"
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="zoomable-overlay__close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
          <div
            className="zoomable-overlay__content"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Zoomable;
